import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg-primary)',
      padding: '40px 24px'
    }}>
      <div style={{
        maxWidth: '900px',
        margin: '0 auto'
      }}>
        {/* Back Link */}
        <Link to="/" style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          color: 'var(--accent-gold)',
          textDecoration: 'none',
          marginBottom: '32px',
          fontSize: '14px'
        }}>
          <ArrowLeft size={16} />
          Back to Home
        </Link>

        {/* Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          marginBottom: '40px'
        }}>
          <div style={{
            width: '56px',
            height: '56px',
            borderRadius: '12px',
            background: 'rgba(212, 175, 55, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <Shield size={28} color="var(--accent-gold)" />
          </div>
          <div>
            <h1 style={{
              fontSize: '32px',
              fontWeight: 700,
              color: 'var(--text-primary)',
              marginBottom: '4px'
            }}>Privacy Policy</h1>
            <p style={{ color: 'var(--text-muted)', fontSize: '14px' }}>
              Last updated: January 2026
            </p>
          </div>
        </div>

        {/* Content */}
        <div style={{
          background: 'var(--bg-secondary)',
          borderRadius: '16px',
          border: '1px solid var(--border-subtle)',
          padding: '40px'
        }}>
          <div style={{ color: 'var(--text-secondary)', lineHeight: 1.8, fontSize: '15px' }}>
            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ color: 'var(--text-primary)', fontSize: '20px', fontWeight: 600, marginBottom: '16px' }}>
                1. Introduction
              </h2>
              <p style={{ marginBottom: '12px' }}>
                PROP INDEXA ("we", "us", or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our proprietary trading services.
              </p>
              <p>
                Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, please do not access the site or use our services.
              </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ color: 'var(--text-primary)', fontSize: '20px', fontWeight: 600, marginBottom: '16px' }}>
                2. Information We Collect
              </h2>
              <p style={{ marginBottom: '12px' }}>We may collect information about you in a variety of ways:</p>
              <ul style={{ marginLeft: '24px', marginBottom: '12px' }}>
                <li style={{ marginBottom: '8px' }}><strong>Personal Data:</strong> Name, email address, phone number, and other contact information you provide during registration.</li>
                <li style={{ marginBottom: '8px' }}><strong>Financial Information:</strong> Cryptocurrency wallet addresses for payout purposes.</li>
                <li style={{ marginBottom: '8px' }}><strong>Trading Data:</strong> Your trading history, performance metrics, and account statistics.</li>
                <li style={{ marginBottom: '8px' }}><strong>Technical Data:</strong> IP address, browser type, device information, and usage patterns.</li>
              </ul>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ color: 'var(--text-primary)', fontSize: '20px', fontWeight: 600, marginBottom: '16px' }}>
                3. How We Use Your Information
              </h2>
              <p style={{ marginBottom: '12px' }}>We use the information we collect to:</p>
              <ul style={{ marginLeft: '24px' }}>
                <li style={{ marginBottom: '8px' }}>Create and manage your trading account</li>
                <li style={{ marginBottom: '8px' }}>Process transactions and send related information</li>
                <li style={{ marginBottom: '8px' }}>Monitor trading activity and ensure compliance with our rules</li>
                <li style={{ marginBottom: '8px' }}>Send you marketing and promotional communications (with your consent)</li>
                <li style={{ marginBottom: '8px' }}>Respond to your comments, questions, and requests</li>
                <li style={{ marginBottom: '8px' }}>Prevent fraudulent transactions and protect against illegal activity</li>
              </ul>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ color: 'var(--text-primary)', fontSize: '20px', fontWeight: 600, marginBottom: '16px' }}>
                4. Data Security
              </h2>
              <p>
                We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse.
              </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ color: 'var(--text-primary)', fontSize: '20px', fontWeight: 600, marginBottom: '16px' }}>
                5. Your Rights
              </h2>
              <p style={{ marginBottom: '12px' }}>You have the right to:</p>
              <ul style={{ marginLeft: '24px' }}>
                <li style={{ marginBottom: '8px' }}>Access and receive a copy of your personal data</li>
                <li style={{ marginBottom: '8px' }}>Rectify any inaccurate personal data</li>
                <li style={{ marginBottom: '8px' }}>Request deletion of your personal data</li>
                <li style={{ marginBottom: '8px' }}>Object to processing of your personal data</li>
                <li style={{ marginBottom: '8px' }}>Withdraw consent at any time</li>
              </ul>
            </section>

            <section>
              <h2 style={{ color: 'var(--text-primary)', fontSize: '20px', fontWeight: 600, marginBottom: '16px' }}>
                6. Contact Us
              </h2>
              <p>
                If you have questions or comments about this Privacy Policy, please contact us through our live chat support or via the contact information provided on our website.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
